import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
import { Autoplay, EffectFade } from 'swiper/modules';
Swiper.use([Autoplay, EffectFade]);

export const RPMTextScroll = (function () {
	'use strict';

	let swiper;

	function setWrapperHeight(swiper) {
		const activeSlide = swiper.slides[swiper.activeIndex];
		const wrapper = swiper.wrapperEl;
	
		if (activeSlide && wrapper) {
			const newHeight = activeSlide.offsetHeight;
			wrapper.style.height = newHeight + 'px';
		}
	}	

	function init() {
		const $el = document.querySelector('.text-scroll-swiper');
		if (!$el) return;

		const speed = parseInt($el.getAttribute('data-rotation-speed')) || 3000;

		swiper = new Swiper($el, {
			direction: 'vertical',
			effect: 'fade',
			fadeEffect: { crossFade: true },
			loop: true,
			autoHeight: false, // disable Swiper's broken handling
			autoplay: {
				delay: speed,
				disableOnInteraction: false,
			},
			on: {
				init: function () {
					setWrapperHeight(this);
				},
				slideChangeTransitionEnd: function () {
					setWrapperHeight(this);
				},
			}
		});
	}

	return {
		init: init
	};
})();